export default __webpack_public_path__ + "static/media/logoWhite.35838692.svg";